import { useState } from 'react'
import { ComplaintStep } from 'features/complaint/constants'
import ComplaintConfirmation from 'features/complaint/views/confirmation/ComplaintConfirmation'
import ComplaintFlow from 'features/complaint/views/flow/ComplaintFlow'

const Complaint = () => {
  // Local state
  const [currentStep, setCurrentStep] = useState<ComplaintStep>('contact')

  if (currentStep === 'confirmation') {
    return <ComplaintConfirmation />
  }

  return <ComplaintFlow {...{ currentStep, setCurrentStep }} />
}

export default Complaint
